import { render, staticRenderFns } from "./EligibilityTable.vue?vue&type=template&id=387bed0f&"
import script from "./EligibilityTable.vue?vue&type=script&lang=js&"
export * from "./EligibilityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports